var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocument({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.208496 2.54167C0.208496 1.43704 1.10387 0.541672 2.2085 0.541672H7.62516C7.82407 0.541672 8.01484 0.620689 8.15549 0.761342L13.5722 6.17801C13.7128 6.31866 13.7918 6.50943 13.7918 6.70834V15.4583C13.7918 16.563 12.8965 17.4583 11.7918 17.4583H2.2085C1.10387 17.4583 0.208496 16.563 0.208496 15.4583V2.54167ZM2.2085 2.04167C1.93229 2.04167 1.7085 2.26547 1.7085 2.54167V15.4583C1.7085 15.7345 1.93229 15.9583 2.2085 15.9583H11.7918C12.068 15.9583 12.2918 15.7345 12.2918 15.4583V7.45834H8.87516C7.77053 7.45834 6.87516 6.56297 6.87516 5.45834V2.04167H2.2085ZM8.37516 3.10233L11.2312 5.95834H8.87516C8.59896 5.95834 8.37516 5.73454 8.37516 5.45834V3.10233ZM3.54183 10.0417C3.54183 9.62746 3.87762 9.29167 4.29183 9.29167H9.7085C10.1227 9.29167 10.4585 9.62746 10.4585 10.0417C10.4585 10.4559 10.1227 10.7917 9.7085 10.7917H4.29183C3.87762 10.7917 3.54183 10.4559 3.54183 10.0417ZM3.54183 12.9583C3.54183 12.5441 3.87762 12.2083 4.29183 12.2083H8.04183C8.45604 12.2083 8.79183 12.5441 8.79183 12.9583C8.79183 13.3726 8.45604 13.7083 8.04183 13.7083H4.29183C3.87762 13.7083 3.54183 13.3726 3.54183 12.9583Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/document.13475b3e7a046d1ab2347b8067cb7451.svg";
export { ForwardRef as ReactComponent };